export interface CurrencyOption {
	code: string
	symbol: string
	label: string
}

export const CURRENCY_OPTIONS: CurrencyOption[] = [
	{ code: "INR", symbol: "₹", label: "Indian Rupee" },
	{ code: "USD", symbol: "$", label: "US Dollar" },
	{ code: "EUR", symbol: "€", label: "Euro" },
	{ code: "GBP", symbol: "£", label: "British Pound" },
	{ code: "JPY", symbol: "¥", label: "Japanese Yen" },
	{ code: "AED", symbol: "د.إ", label: "UAE Dirham" },
	{ code: "AUD", symbol: "A$", label: "Australian Dollar" },
	{ code: "CAD", symbol: "C$", label: "Canadian Dollar" },
	{ code: "SGD", symbol: "S$", label: "Singapore Dollar" },
]

export const formatPrice = (value: number, currencyCode?: string) => {
	const normalized = (currencyCode || "USD").toUpperCase()

	try {
		return new Intl.NumberFormat(undefined, {
			style: "currency",
			currency: normalized,
			maximumFractionDigits: 2,
		}).format(value)
	} catch {
		const option = CURRENCY_OPTIONS.find((c) => c.code === normalized)
		const prefix = option ? option.symbol : `${normalized} `
		return `${prefix}${value.toFixed(2)}`
	}
}
